module.exports = __webpack_public_path__ + "static/img/2b.6afcffeb.webp";